import * as actions from './ui.actions';
import * as selectors from './ui.selectors';
import { reducer, uiFeatureKey } from './ui.reducer';
// UiStoreModule is no longer imported or exported

export const UiStore = {
  actions,
  selectors,
  reducer,
  config: { name: uiFeatureKey, reducer },
  // StoreModule is no longer needed
};
